<div class="card">
    <div class="card-body">
        <div class="heading gap-4 w-full">
            <h6 class="text-lg text-gray-500 font-semibold mb-6 whitespace-nowrap">
                Admin Users
            </h6>
            <div class="">
                <div class="relative flex items-center">
                    <input
                        type="text"
                        [(ngModel)]="searchQuery"
                        (keyup.enter)="onSearch(searchQuery)"
                        (input)="onSearchInputChanged()"
                        placeholder="Search admins..."
                        class="w-full py-2 px-4 border rounded-xl focus:outline-none focus:ring-2 focus:ring-gray-500"
                    />
                    <button
                        class="bg-gray-500 text-white px-4 rounded-xl hover:bg-gray-600 search-button"
                        (click)="onSearch(searchQuery)"
                    >
                        <i class="uil uil-search"></i>
                    </button>
                </div>
            </div>
    </div>
        <app-preloader *ngIf="loading"></app-preloader>
        <div class="relative overflow-x-auto" *ngIf="!loading">
            <table class="text-left w-full whitespace-nowrap text-sm text-gray-500">
                <thead>
                    <tr class="text-sm">
                        <th scope="col" class="p-4 font-semibold">Profile</th>
                        <th scope="col" class="p-4 font-semibold">Availability</th>
                        <th scope="col" class="p-4 font-semibold">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let user of users | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: totalItems
                      };
                  let i = index">
                        <td class="p-4 text-sm">
                            <div class="flex gap-6 items-center">
                                <div class="h-12 w-12 inline-block"><img [src]="user.profileImageUrl" alt=""
                                        class="rounded-full w-100"></div>
                                <div class="flex flex-col gap-1 text-gray-500">
                                    <div class="flex flex-col gap-1 text-gray-500">
                                        <h3 class=" font-bold">{{ user.username}}</h3>
                                    </div>
                                    <span class="font-normal">{{ user.email}}</span>
                                </div>
                            </div>
                        </td>
                        <td class="p-4">
                            <span class="inline-flex items-center py-2 px-4 rounded-3xl font-semibold bg-gray-200 text-gray-400" *ngIf="user.email != 'mcangelo200@gmail.com'">Offline</span>
                            <span class="inline-flex items-center py-2 px-4 rounded-3xl font-semibold bg-teal-400 text-teal-500" *ngIf="user.email == 'mcangelo200@gmail.com'">Online</span>
                        </td>
                        <td >
                            <div class="flex gap-3">

                                <!-- <button type="button" class="py-2 px-4 inline-flex items-center gap-x-2 font-semibold rounded-2xl border text-gray border-gray-200 hover:border-gray-200 hover:text-white hover:bg-gray-500"></button> -->
                                <button type="button" class="py-2 px-4 inline-flex items-center gap-x-2 font-semibold rounded-2xl border border-red-500 text-red-500 hover:border-red-200 hover:text-white hover:bg-red-500" (click)="triggerDelete(user)">
                                    <i class="ti ti-trash"></i> 
                                </button>
                                
                                <button type="button" class="py-2 px-4 inline-flex items-center gap-x-2 font-semibold rounded-2xl border text-gray border-gray-200 hover:border-gray-200 hover:text-white hover:bg-gray-500" 
                                routerLink="/portal/user/{{user._id}}/profile">
                                <i class="ti ti-eye"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="card" *ngIf="totalItems > pageSize">
    <div class="card-body flex justify-center" style="margin-top: 20px;">
        <nav class="flex justify-center items-center">
            <pagination-controls (pageChange)="renderPage($event)"></pagination-controls>
          </nav>
    </div>
</div>